import { LitElement, html, svg } from 'lit';

export class IconLayers32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Tre kvadrater som flyter inn i hverandre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m1 16 15 6 15-6M16 3 1 9l15 6 15-6-15-6ZM1 23l15 6 15-6"></path></svg>`; }
}
if (!customElements.get('f-icon-layers32', IconLayers32)) {
  customElements.define('f-icon-layers32', IconLayers32);
}